var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCcPlaceholder = function SvgCcPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "-5 1 29 29",
    fill: "#CECECE"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 4H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 9.78A.78.78 0 0 1 3.78 9h.428v1.125H3V9.78zm0 .764h1.208v.968H3v-.968zm0 1.388h1.208V13H3.78a.78.78 0 0 1-.78-.78v-.288zM6 17H3v-1h3v1zm1-4.78a.78.78 0 0 1-.78.78h-.429v-1.068H7v.288zm0-.708H5.791v-.968H7v.968zm0-1.387H5.371V13h-.743V9H6.22a.78.78 0 0 1 .78.78v.345zM11 17H8v-1h3v1zm1-6.5a2.5 2.5 0 0 1 3.82-2.123 3.055 3.055 0 0 0 0 4.246A2.5 2.5 0 0 1 12 10.5zm4 6.5h-3v-1h3v1zm5 0h-3v-1h3v1zm-2.5-4a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
  })));
};
export default SvgCcPlaceholder;